import { BigRational } from 'big-rational-ts';
import BigNumber from 'bignumber.js';

export function bigNumberToBigRational(bigNumber: BigNumber): BigRational {
  if (bigNumber.eq(0)) return new BigRational(0n, 1n);
  const [numerator, denominator] = bigNumber
    .toFraction()
    .map((x) => BigInt(x.toFixed(0)));
  return new BigRational(numerator, denominator).reduce();
}

/**
 * Warning: conversion might lose precision,e.g, 1/3 -> 0.33333333333333333333 != 1/3
 */
export function bigRationalToBigNumber(bigRational: BigRational): BigNumber {
  const numerator = BigNumber(bigRational.getNumerator().toString());
  const denominator = BigNumber(bigRational.getDenominator().toString());
  return numerator.div(denominator);
}

/**
 * Converts the numeric format (from postgreSQL) into a BigRational instance
 *
 * @param dbNumber - string that represents number in the numeric postgreSQL format
 * @returns BigRational instance
 */
export function dbNumericToBigRational(dbNumber: string): BigRational {
  return bigNumberToBigRational(dbNumericToBigNumber(dbNumber));
}

/**
 * Converts the numeric format (from postgreSQL) into a BigNumber instance
 *
 * @param dbNumber - string that represents number in the numeric postgreSQL format
 * @returns BigNumber instance
 */
function dbNumericToBigNumber(dbNumber: string): BigNumber {
  return BigNumber(dbNumber);
}

export const min = (a: bigint, b: bigint) => (a < b ? a : b);
